export default {
  blue: `#356DD4`,
  purple: `#083D77`,
  green: `#0CE9DE`,
  paper: `rgba(239, 239, 239, 1)`,
  red: `rgba(255, 73, 92, 1)`,
  black: `rgba(58, 54, 54, 1)`,
  white: `rgba(255, 255, 255, 1)`,
}
